import { createApp } from 'vue'
import UsluSayi from './UsluSayi.vue'
import './assets/global.css'

createApp(UsluSayi).mount('#uslu-sayi')
